document.addEventListener ('DOMContentLoaded', function () {

    if (document.getElementsByClassName ('product-gallery').length) {

        var prevButton = document.getElementById ('prevButton');
        var nextButton = document.getElementById ('nextButton');

        var splide = new Splide ('.product-gallery', {
            perPage: 1,
            mediaQuery: 'min',
            gap: '20px',
            breakpoints: {
                1200: {
                    destroy: true
                }
            }
        }).mount ();
    }

    if (document.getElementsByClassName ('product-image-gallery').length) {

        // var prevButton = document.getElementById ('prevButton');
        // var nextButton = document.getElementById ('nextButton');

        new Splide ('.product-image-gallery').mount ();
    }
});